module["exports"] = [
  "#####",
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de/address/postcode.js
// module id = 818
// module chunks = 0